"use client";
import React, { useState } from "react";
import { useDictionary } from "../../../../context/dictionaryProvider";
import BaseAccordion from "../../../../components/accordion";
import Link from "next/link";

const TableOfContent = ({ data, className, showExpandTable = false }) => {
  const [content, setContent] = useState(data?.content?.slice(0, 2) || []);
  const [showMore, setShowMore] = useState(false);
  const [isToggled, setIsToggled] = useState(!showExpandTable);

  const dict = useDictionary();

  const hanldeClick = (e) => {
    console.log(e.target.value);
    e.preventDefault();
    setShowMore(!showMore);
    setContent(showMore ? data?.content?.slice(0, 2) : data?.content);
  };

  return (
    <>
      {data && (
        <div
          className={`${
            className ? className : ""
          } relative w-full border border-black rounded-2xl py-5 lg:py-9 px-5 shadow-[0px_4px_4px_0px_rgba(0, 0, 0, 0.03)] mb-3 lg:mb-32`}
        >
          <BaseAccordion
            containerSpace="px-0"
            showHeaderIcon={false}
            blogDataDiv="mb-0 !flex-nowrap justify-between"
            blogDataTitle="text-lg font-extrabold lg:mb-10"
            space="px-0"
            title={data?.title}
            itemsDiv="border-b-1 border-b-black py-5"
            arrowIcon="text-[#0096AE]"
            data={content}
            showExpandTable={showExpandTable}
            onToggle={setIsToggled}
          />
          {isToggled && (
            <Link
              prefetch={false}
              href="#"
              className="primaryLinkTxt flex gap-4 items-start mt-6 underline underline-offset-4 text-[#0096AC] px-4"
              onClick={hanldeClick}
            >
              {showMore ? dict?.viewLess : dict?.viewMore}
            </Link>
          )}
        </div>
      )}
    </>
  );
};

export default TableOfContent;
